import { Card, Icon, Stack, Typography } from "@mui/material";
export type TileProps = {
  label: string;
  icon: string;
  onClick: () => void;
};
import { useRef } from "react";

export function Tile(props: TileProps) {
  const tileRef = useRef<HTMLDivElement>();

  return (
    <Card
      ref={tileRef}
      sx={{
        borderRadius: "4px",
        padding: "10pX",
        boxShadow:
          "0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);",
        height: "180px",
        width: "180px",
        cursor: "pointer",
      }}
      onClick={props.onClick}
    >
      <Stack
        justifyContent={"space-between"}
        sx={{
          height: "100%",
          paddingBottom: 4,
        }}
        alignItems={"center"}
        spacing={2}
      >
        <Typography sx={{ color: "primary.main" }}>{props.label}</Typography>
        <Icon
          className={props.icon}
          sx={{ fontSize: "68px", color: "primary.main" }}
        ></Icon>
      </Stack>
    </Card>
  );
}
